import Route from "@mpa/toolbox/navigation/Route";

import { loggedInNavigator } from "../../navigation/routes";

export const processRoute = loggedInNavigator.addRoute(
    new Route().setPath("/la-procedure-d-adoption"),
);
